import { en } from './en.js'

export const id = structuredClone(en)

id.visualGameAdmin.conversionFunnelDevices = {'label': 'Jenis perangkat sumber', 'all': 'Semua', 'desktop': 'Komputer', 'mobile': 'Ponsel', 'tablet': 'Tablet'}

id.visualGameAdmin.pageFunnel = {'button': 'Lihat corong halaman', 'title': 'Corong halaman', 'home': 'Beranda', 'auth': 'Masuk atau daftar', 'game': 'Halaman permainan', 'note': 'Sesi yang melewati langkah berurutan sesuai waktu dan perangkat. Termasuk dialog masuk PC. Data historis tanpa pelacakan tidak dapat dipulihkan.', 'loading': 'Memuat…', 'error': 'Gagal memuat', 'sessions': 'sesi'}

id.visualGameAdmin.pageFunnel.viewUsers = 'Lihat pengguna'
id.visualGameAdmin.pageFunnel.peopleUnit = 'pengguna'
id.visualGameAdmin.pageFunnel.timesUnit = 'kali'

id.visualGameAdmin.pageFunnel.userFilter_all = 'Corong: daftar atau masuk'

id.visualGameAdmin.pageFunnel.userFilter_sign_up = 'Corong: terdaftar dalam periode'

id.visualGameAdmin.pageFunnel.userFilter_login = 'Corong: masuk dalam periode'

id.visualGameAdmin.usageActivity = {
  "title": "Penggunaan situs · Aktivitas",
  "button": "Lihat detail",
  "all": "Semua aktivitas",
  "search": "Cari pengguna, game atau ID",
  "user": "Pengguna",
  "game": "Game",
  "kind": "Aktivitas",
  "status": "Status",
  "time": "Waktu",
  "detail": "Lihat catatan",
  "empty": "Tidak ada catatan",
  "loading": "Memuat…",
  "error": "Gagal memuat",
  "note": "Input menggunakan peristiwa pihak pertama dan dapat berbeda dari GA4. Teks dan sesi yang tidak tercatat tidak disimpulkan.",
  "limit": "Menampilkan 1000 catatan terbaru. Persempit rentang tanggal untuk melihat lainnya.",
  "text_input": "Input teks",
  "voice_input": "Input suara",
  "slice_video": "Pembuatan klip",
  "global_video": "Pembuatan video lengkap",
  "free_game": "Pembuatan game gratis"
}

Object.assign(id.visualGameAdmin.usageActivity, {
  "status_queued": "Antrean",
  "status_running": "Berjalan",
  "status_ready": "Selesai",
  "status_failed": "Gagal",
  "status_submitting": "Mengirim",
  "status_submitted": "Terkirim",
  "status_ok": "Berhasil",
  "status_error": "Gagal",
  "status_generating": "Membuat",
  "status_generation_failed": "Pembuatan gagal",
  "status_pending_review": "Menunggu tinjauan",
  "status_review_rejected": "Ditolak",
  "status_published": "Diterbitkan",
  "status_archived": "Diarsipkan"
})

id.visualGameAdmin.usageActivity.records = 'catatan'

id.visualGameAdmin.paypointActivity = {
  "title": "Titik pembayaran · Detail",
  "all": "Semua",
  "game": "Halaman",
  "kind": "Konteks pembayaran",
  "status": "Pemicu",
  "note": "Catatan pihak pertama dapat berbeda dari GA4. Membuka dialog video tidak berarti kredit kurang. Catatan lama tidak menyimpan saldo, biaya atau ID sesi.",
  "billing_paypoint_gameplay": "Gameplay",
  "billing_paypoint_ending_video": "Video akhir",
  "billing_paypoint_story_video": "Video cerita",
  "status_insufficient_balance": "Kredit permainan kurang",
  "status_dialog_open": "Dialog pembuatan dibuka"
}

id.visualGameAdmin.paypointActivity.search = 'Cari pengguna, halaman atau ID'

id.visualGameAdmin.orderDrilldown = {
  "button": "Lihat pesanan",
  "dateField": "Dasar waktu",
  "created_at": "Waktu dibuat",
  "paid_at": "Waktu dibayar"
}

Object.assign(id.visualGameAdmin.orderDrilldown, {
  "since": "Waktu mulai",
  "until": "Waktu akhir"
})

id.visualGameAdmin.orderDrilldown.updated_at = 'Waktu pembaruan status'

id.visualGameAdmin.trafficBaseline = {
  "confirmed": "Pertambahan terkonfirmasi",
  "first": "Tayangan pertama (belum dikonfirmasi)",
  "missing": "Data awal tidak ada; pertambahan tidak lengkap",
  "note": "Tanpa catatan sebelum periode, tayangan pertama ditampilkan terpisah dan tidak masuk pertambahan terkonfirmasi. Tanggal pengamatan bukan tanggal publikasi.",
  "observed": "Tanggal pengamatan pertama",
  "filter": "Data awal tidak ada",
  "unchanged": "Tidak bertambah (data awal lengkap)",
  "later": "Pertambahan setelah pengamatan pertama"
}

id.visualGameAdmin.funnelAuth = {
  registration: 'Pendaftaran situs',
  login: 'Login situs',
  new_users: 'Login pengguna baru',
  existing_users: 'Login pengguna lama',
  note: 'Pengguna baru mendaftar dalam periode terpilih; pengguna lama mendaftar sebelumnya. Klasifikasi berdasarkan waktu pendaftaran. Pengguna dihitung unik; jumlah login berdasarkan login berhasil.',
  user_type: 'Jenis pengguna',
  registered_at: 'Waktu pendaftaran',
  new_type: 'Pengguna baru',
  existing_type: 'Pengguna lama'
}

id.visualGameAdmin.funnelPeriods = {
  yesterday: 'Kemarin',
  last_three_days: '3 hari terakhir'
}
